import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Flex,
  FormLabel,
  Table,
  TableContainer,
  Tbody,
  useDisclosure,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { RanaButton } from "@nens/ranalib";

import { MetadataItems } from "../dataset-detail";

import { MetadataItemsList } from "./dataset-detail-metadata-item";

type DatasetDetailMetadataTableProps = {
  label: ReactNode;
  items: MetadataItems[number][];
  collapsableItems?: MetadataItems[number][];
};

export const DatasetDetailMetadataTable = ({
  label,
  items,
  collapsableItems,
}: DatasetDetailMetadataTableProps) => {
  const hasCollapsableItems = collapsableItems && collapsableItems.length > 0;
  const { isOpen, onToggle } = useDisclosure();
  return (
    <Box _notLast={{ mb: 4 }}>
      <Flex mb={2} justifyContent="space-between" alignItems="center">
        <FormLabel fontSize="l">{label}</FormLabel>
        {hasCollapsableItems && (
          <RanaButton
            h="fit"
            variant="ghost"
            onClick={onToggle}
            justifyContent="flex-end"
            textDecor="underline"
            _hover={{ bg: "inherit" }}
            p={0}
          >
            <ChevronDownIcon />
            {isOpen ? (
              <FormattedMessage
                id="process.status.hide_technical"
                defaultMessage="Hide technical details"
              />
            ) : (
              <FormattedMessage
                id="process.status.show_technical"
                defaultMessage="Show technical details"
              />
            )}
          </RanaButton>
        )}
      </Flex>

      <Box borderWidth="base" rounded="base" bg="brand.grey.100" maxW="full">
        <TableContainer px={4} pt={4} pb={0}>
          <Table layout="fixed" variant="unstyled">
            <Tbody>
              <MetadataItemsList metadataItems={items} />
            </Tbody>
          </Table>

          {hasCollapsableItems && (
            <Collapse in={isOpen}>
              <Table layout="fixed" variant="unstyled">
                <Tbody>
                  <MetadataItemsList metadataItems={collapsableItems} />
                </Tbody>
              </Table>
            </Collapse>
          )}
        </TableContainer>
      </Box>
    </Box>
  );
};
